// @core/api/endpoints/notifications/create_notification_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateNotificationTemplateRequest,
  TemplateResponse,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Create notification template
 * Creates a new notification template with customizable content and variables. Templates can be used to standardize notification messages across the platform.
 */
export async function CreateNotificationTemplate(
  data: CreateNotificationTemplateRequest,
  options?: RequestOptions
): Promise<TemplateResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/templates`;
  const requestOptions = options;
  return client.post<TemplateResponse>(requestPath, data, requestOptions);
}
